import React from 'react';
import PaymentRequestsList from '../components/PaymentRequestsList';

const PaymentRequests = () => {
  return <PaymentRequestsList />;
};

export default PaymentRequests;
